import { MulticastDelegate1 } from "flavr-common";
class MouseService {
    constructor() {
        this.move$ = new MulticastDelegate1();
        this.down$ = new MulticastDelegate1();
        this.up$ = new MulticastDelegate1();
        this.wheel$ = new MulticastDelegate1();
    }
    register(element) {
        element.onmousemove = (event) => {
            this.move$.invoke(event);
        };
        element.onmousedown = (event) => {
            this.down$.invoke(event);
        };
        element.onmouseup = (event) => {
            this.up$.invoke(event);
        };
        element.addEventListener("wheel", (event) => {
            this.wheel$.invoke(event);
        }, { passive: true });
    }
}
export const mouseService = new MouseService();
